<div class="status-light">
  @if (color) {
  <div [ngClass]="['light']" [ngStyle]="{ 'background-color': color }"></div>
  } @if (tipText) {
  <div [cdsTooltip]="tipText" (mouseenter)="onMouseenter($event)" (mouseleave)="onMouseleave($event)">
    <span class="status-text">{{ text }}</span>
  </div>
  } @if (!tipText) {
  <div>
    <span>{{ text }}</span>
  </div>
  }
</div>
